import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class EarningService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    getPairingBonus(data): Observable<any> {
        return this.getRequest(AppUrl.PAIRING_BONUS(), data);
    }

    getPairingBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.PAIRING_BONUS_COUNT(), data);
    }

    getMonthlyPairingBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.MONTHLY_PAIRING_BONUS_COUNT(), data);
    }

    getSelfRepurchaseBonus(data): Observable<any> {
        return this.getRequest(AppUrl.SELF_REPURCHASE_BONUS(), data);
    }

    getSelfRepurchaseBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.SELF_REPURCHASE_BONUS_COUNT(), data);
    }

    getSelfRepurchaseTodayBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.SELF_REPURCHASE_TODAY_BONUS_COUNT(), data);
    }

    getPerformanceBonus(data): Observable<any> {
        return this.getRequest(AppUrl.PERFORMANCE_BONUS(), data);
    }

    getPerformanceBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.PERFORMANCE_BONUS_COUNT(), data);
    }

    getPerformanceTodayBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.PERFORMANCE_TODAY_BONUS_COUNT(), data);
    }

    getDirectorBonus(data): Observable<any> {
        return this.getRequest(AppUrl.DIRECTOR_BONUS(), data);
    }

    getDirectorBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.DIRECTOR_BONUS_COUNT(), data);
    }

    getDirectorTodayBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.DIRECTOR_TODAY_BONUS_COUNT(), data);
    }

    getLeadershipBonus(data): Observable<any> {
        return this.getRequest(AppUrl.LEADERSHIP_BONUS(), data);
    }

    getLeadershipBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.LEADERSHIP_BONUS_COUNT(), data);
    }

    getLeadershipTodayBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.LEADERSHIP_TODAY_BONUS_COUNT(), data);
    }

    getHouseFundBonus(data): Observable<any> {
        return this.getRequest(AppUrl.HOUSE_FUND_BONUS(), data);
    }

    getHouseFundBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.HOUSE_FUND_BONUS_COUNT(), data);
    }

    getHouseFundTodayBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.HOUSE_FUND_TODAY_BONUS_COUNT(), data);
    }

    getCarFundBonus(data): Observable<any> {
        return this.getRequest(AppUrl.CAR_FUND_BONUS(), data);
    }

    getCarFundBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.CAR_FUND_BONUS_COUNT(), data);
    }


    getCarFundTodayBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.CAR_FUND_TODAY_BONUS_COUNT(), data);
    }

    getTourFundBonus(data): Observable<any> {
        return this.getRequest(AppUrl.TOUR_FUND_BONUS(), data);
    }

    getTourFundBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.TOUR_FUND_BONUS_COUNT(), data);
    }

    getTourFundTodayBonusCount(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.TOUR_FUND_TODAY_BONUS_COUNT(), data);
    }
}
